<template>
  <div class="login-page">
    <!-- 背景动画层 -->
    <div class="bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>

    <!-- 登录卡片 -->
    <div class="login-card">
      <div class="card-header">
        <div class="header-icon">
          <i class="el-icon-s-home"></i>
        </div>
        <h1>智慧养老后台管理系统</h1>
        <p class="subtitle">Smart Elderly Care Management</p>
      </div>

      <el-form
        ref="loginForm"
        :model="form"
        :rules="rules"
        size="medium"
        @submit.native.prevent="onSubmit"
        class="login-form"
      >
        <el-form-item prop="username">
          <el-input
            ref="usernameInput"
            v-model="form.username"
            placeholder="请输入账号"
            prefix-icon="el-icon-user"
            @keyup.enter.native="focusPassword"
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            ref="passwordInput"
            v-model="form.password"
            :type="showPassword ? 'text' : 'password'"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            @keyup.enter.native="onSubmit"
          >
            <i
              slot="suffix"
              :class="showPassword ? 'el-icon-view' : 'el-icon-lock'"
              class="toggle-password"
              @click="showPassword = !showPassword"
            />
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            native-type="submit"
            :loading="loading"
            :disabled="loading"
            class="login-btn"
          >
            {{ loading ? '登录中...' : '登 录' }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 底部版权 -->
    <div class="footer-copy">
      <span>&copy; {{ currentYear }} 智慧养老管理系统</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 位', trigger: 'blur' }
        ]
      },
      loading: false,
      showPassword: false
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.usernameInput.focus()
    })
  },
  methods: {
    focusPassword() {
      this.$refs.passwordInput.focus()
    },
    onSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return

        this.loading = true
        this.$util.post('login', this.form)
          .then(res => {
            sessionStorage.setItem('adminer', res.data.name)
            sessionStorage.setItem('token', res.data.api_token)
            sessionStorage.setItem('userHead', res.data.photo)
            sessionStorage.setItem('roleList', JSON.stringify(res.data.roles))
            sessionStorage.setItem('systemUserId', res.data.id)

            if (res.data.staff && res.data.staff.sex) {
              sessionStorage.setItem('sex', res.data.staff.sex)
            } else {
              sessionStorage.setItem('sex', 0)
            }

            this.$message({
              message: `欢迎回来，${res.data.name || ''}`,
              type: 'success',
              duration: 1500
            })

            setTimeout(() => {
              if (this.$route.query.redirect) {
                this.$router.push(this.$route.query.redirect)
              } else {
                this.$router.push('/')
              }
            }, 400)
          })
          .catch(err => {
            this.$message({
              message: (err && err.data && err.data.msg) || '登录失败，请检查账号密码',
              type: 'error',
              duration: 3000
            })
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', Arial, sans-serif;
}

/* 背景装饰图形 */
.bg-shapes {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  animation: float 20s infinite ease-in-out;
}

.shape-1 {
  width: 500px;
  height: 500px;
  top: -150px;
  right: -100px;
  animation-delay: 0s;
}

.shape-2 {
  width: 400px;
  height: 400px;
  bottom: -120px;
  left: -80px;
  animation-delay: -7s;
}

.shape-3 {
  width: 300px;
  height: 300px;
  top: 40%;
  left: 50%;
  animation-delay: -14s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) scale(1);
  }
  25% {
    transform: translateY(-30px) scale(1.05);
  }
  50% {
    transform: translateY(-15px) scale(0.95);
  }
  75% {
    transform: translateY(-40px) scale(1.02);
  }
}

/* 登录卡片 */
.login-card {
  position: relative;
  width: 420px;
  max-width: 92vw;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.3);
  padding: 48px 40px 36px;
  animation: card-enter 0.6s ease-out;
  z-index: 1;
}

@keyframes card-enter {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 卡片头部 */
.card-header {
  text-align: center;
  margin-bottom: 36px;
}

.header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 20px;
  border-radius: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.35);
  animation: icon-pulse 3s infinite ease-in-out;
}

.header-icon i {
  font-size: 32px;
  color: #fff;
}

@keyframes icon-pulse {
  0%,
  100% {
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.35);
  }
  50% {
    box-shadow: 0 8px 36px rgba(102, 126, 234, 0.55);
  }
}

.card-header h1 {
  font-size: 22px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px;
  letter-spacing: 1px;
}

.subtitle {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
  letter-spacing: 0.5px;
}

/* 表单 */
.login-form {
  margin-top: 8px;
}

.login-form ::v-deep .el-input__prefix {
  left: 12px;
}

.login-form ::v-deep .el-input__prefix .el-icon-user,
.login-form ::v-deep .el-input__prefix .el-icon-lock {
  color: #94a3b8;
  font-size: 16px;
}

.login-form ::v-deep .el-input__inner {
  height: 46px;
  line-height: 46px;
  padding-left: 40px;
  padding-right: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  font-size: 14px;
  transition: all 0.25s ease;
}

.login-form ::v-deep .el-input__inner:hover {
  border-color: #94a3b8;
}

.login-form ::v-deep .el-input__inner:focus,
.login-form ::v-deep .el-input.is-focus .el-input__inner {
  border-color: #667eea;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.12);
}

/* 密码切换图标 */
.toggle-password {
  font-size: 16px;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.2s;
  line-height: 46px;
}

.toggle-password:hover {
  color: #667eea;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 46px;
  border-radius: 10px;
  font-size: 16px;
  letter-spacing: 4px;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transition: all 0.3s ease;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
}

.login-btn:active:not(:disabled) {
  transform: translateY(0);
}

.login-btn.is-loading {
  opacity: 0.85;
}

.login-btn ::v-deep span {
  font-weight: 500;
}

/* 底部版权 */
.footer-copy {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 0.5px;
  z-index: 1;
}

/* 响应式 */
@media screen and (max-width: 480px) {
  .login-card {
    padding: 36px 24px 28px;
    border-radius: 12px;
  }

  .card-header h1 {
    font-size: 18px;
  }

  .header-icon {
    width: 52px;
    height: 52px;
    border-radius: 14px;
  }

  .header-icon i {
    font-size: 26px;
  }

  .login-btn {
    font-size: 15px;
    letter-spacing: 2px;
  }
}

/* 尊重用户减少动画偏好 */
@media (prefers-reduced-motion: reduce) {
  .login-card {
    animation: none;
  }
  .shape {
    animation: none;
  }
  .header-icon {
    animation: none;
  }
}
</style>
